module.exports = __webpack_public_path__ + "img/CompScope_Bright_01.c106c909.png";